module.exports = __webpack_public_path__ + "static/media/54 - IMAGAMA Logo.e4eb2e4e.png";